// 车辆管理
export default [
  {
    path: '/partsConsume',
    name: 'partsConsume',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/vehicleConfig/partsConsume.vue'], resolve)
    }
  },
  {
    path: '/accidentInfo',
    name: 'accidentInfo',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/vehicleConfig/accidentInfo.vue'], resolve)
    }
  },
  {
    path: '/vehicleConfig',
    name: 'vehicleConfig',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/vehicleConfig/vehicleConfig.vue'], resolve)
    }
  },
  {
    path: '/vehicleTypeConfig',
    name: 'vehicleTypeConfig',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/vehicleConfig/vehicleTypeConfig.vue'], resolve)
    }
  }
  ,
  {
    path: '/quotaConfig',
    name: 'quotaConfig',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/vehicleConfig/quotaConfig.vue'], resolve)
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/vehicleConfig.js